import React, { forwardRef, JSX } from "react";
import styles from "./style.module.css";
import Spinner from "../spinner";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: JSX.Element;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
}

const ButtonIcon = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    icon,
    onClick,
    disabled = false,
    type = "button",
    className = "",
    loading = false,
    ...restProps
  } = props;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <button
      ref={ref}
      type={type}
      className={`${styles.button} ${
        disabled ? styles["button--disabled"] : ""
      } ${className}`}
      onClick={handleClick}
      disabled={disabled}
      aria-disabled={disabled}
      {...restProps}
    >
      <span className={styles.button__label}>
        {loading ? <Spinner color={"white"}/> : icon}
      </span>
    </button>
  );
});

ButtonIcon.displayName = "Button";

export default ButtonIcon;